// extracted by mini-css-extract-plugin
export default {"backdrop":"spinner_backdrop__cUtlz","spinner":"spinner_spinner__Rs4Rd","spin":"spinner_spin__kerlz"};